<template>
    <div class="page-preloader"/>
</template>

<script>
    export default {
        name: "loader"
    };
</script>
